<template>
  <div style="background:#fff; border-radius: 8px; box-shadow: 0 4px 25px rgba(0,0,0,0.06); overflow:hidden;">
    <table class="data-table">
      <thead>
        <tr>
          <th v-for="coluna in columns" :key="coluna.key" :style="{ width: coluna.width }">
            {{ coluna.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="loading">
          <td :colspan="columns.length" style="text-align:center; color:#9a9a9a; padding: 32px;">Carregando...</td>
        </tr>
        <tr v-else-if="rows.length === 0">
          <td :colspan="columns.length" style="text-align:center; color:#9a9a9a; padding: 32px;">
            {{ emptyText }}
          </td>
        </tr>
        <tr v-for="(row, index) in rows" :key="row.id != null ? row.id : index">
          <td v-for="coluna in columns" :key="coluna.key">
            <slot :name="'cell-' + coluna.key" :row="row">{{ row[coluna.key] }}</slot>
          </td>
        </tr>
      </tbody>
    </table>

    <div
      v-if="!loading && rows.length > 0"
      style="display:flex; align-items:center; justify-content:space-between; padding: 14px 20px; border-top: 1px solid #edeef0;"
    >
      <div style="font-size:12px; color:#9a9a9a;">
        Mostrando {{ rows.length }} de {{ total }}
      </div>
      <div style="display:flex; gap:6px;">
        <button
          type="button"
          class="data-table-page-btn"
          :disabled="pagina <= 1"
          @click="$emit('mudar-pagina', pagina - 1)"
        >‹</button>
        <template v-for="(p, index) in paginasVisiveis">
          <span v-if="p === '...'" :key="'ellipsis-' + index" class="data-table-page-ellipsis">…</span>
          <button
            v-else
            :key="p"
            type="button"
            class="data-table-page-btn"
            :class="{ 'data-table-page-btn--ativo': p === pagina }"
            @click="$emit('mudar-pagina', p)"
          >{{ p }}</button>
        </template>
        <button
          type="button"
          class="data-table-page-btn"
          :disabled="pagina >= totalPaginas"
          @click="$emit('mudar-pagina', pagina + 1)"
        >›</button>
      </div>
    </div>
  </div>
</template>
<script>
// Tabela paginada/filtravel generica - o consumidor manda colunas + linhas
// e usa slots (#cell-<key>) pra customizar celulas (ex: badge de status).
// Primeiro consumidor: tela de conferencia diaria (issue #312).
export default {
  name: "DataTable",
  props: {
    columns: { type: Array, required: true }, // [{ key, label, width? }]
    rows: { type: Array, required: true },
    loading: { type: Boolean, default: false },
    emptyText: { type: String, default: "Nenhum registro encontrado." },
    pagina: { type: Number, default: 1 },
    totalPaginas: { type: Number, default: 1 },
    total: { type: Number, default: 0 }
  },
  computed: {
    // Janela de paginas visiveis (atual +-1, sempre primeira/ultima, "..." nos
    // buracos) - sem isso, um dia com muitas notas gera um botao por pagina
    // sem limite, quebrando o layout do rodape.
    paginasVisiveis() {
      const total = this.totalPaginas;
      const atual = this.pagina;
      const vizinhanca = 1;
      const paginas = new Set([1, total, atual]);
      for (let i = 1; i <= vizinhanca; i++) {
        if (atual - i >= 1) paginas.add(atual - i);
        if (atual + i <= total) paginas.add(atual + i);
      }
      const ordenadas = [...paginas].sort((a, b) => a - b);

      const resultado = [];
      let anterior = null;
      for (const p of ordenadas) {
        if (anterior !== null && p - anterior > 1) resultado.push("...");
        resultado.push(p);
        anterior = p;
      }
      return resultado;
    }
  }
};
</script>
<style scoped>
.data-table { border-collapse: collapse; width: 100%; }
.data-table th {
  text-align: left; font-size: 11px; font-weight: 600; letter-spacing: 0.04em;
  text-transform: uppercase; color: #8b8b8b; padding: 12px 16px; background: #fafafa;
  border-bottom: 1px solid #edeef0;
}
.data-table td { padding: 14px 16px; font-size: 13.5px; border-bottom: 1px solid #edeef0; vertical-align: middle; }
.data-table tr:last-child td { border-bottom: none; }
.data-table tr:hover td { background: #fcfcfd; }
.data-table-page-btn {
  width: 28px; height: 28px; border-radius: 6px; border: 1px solid #e5e6e8; background: #fff;
  font-size: 12px; color: #5b5b5b; cursor: pointer;
}
.data-table-page-btn:disabled { color: #d6d7da; cursor: default; }
.data-table-page-btn--ativo { background: #ffca00; border-color: #ffca00; color: #1f1f1f; font-weight: 700; }
.data-table-page-ellipsis { width: 28px; height: 28px; display:flex; align-items:center; justify-content:center; color: #c4c4c4; font-size: 12px; }
</style>
